const homePageJurisdiction = {
  id: "000000000",
  label: "首页",
  routerName: "workbench",
  children: []
};

export { homePageJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/homePageJurisdiction.js